import { render, staticRenderFns } from "./ControllPanel.vue?vue&type=template&id=151fa6ef&scoped=true&"
import script from "./ControllPanel.vue?vue&type=script&lang=js&"
export * from "./ControllPanel.vue?vue&type=script&lang=js&"
import style0 from "./ControllPanel.vue?vue&type=style&index=0&id=151fa6ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151fa6ef",
  null
  
)

export default component.exports